import ReactDOM from 'react-dom'
import React, { useEffect, useRef } from 'react'

import * as Styles from './styles'

interface IProps {
  label: string
  onSkipAll: () => void
}

export const SkipButton: React.FC<IProps> = ({ label, onSkipAll }) => {
  const divRef = useRef(document.createElement('div'))

  useEffect(() => {
    const div = divRef.current
    document.body.appendChild(div)
    return () => div.remove()
  }, [])

  return ReactDOM.createPortal(
    <Styles.SkipButtonContainer>
      <Styles.SkipButton onClick={() => onSkipAll()}>{label}</Styles.SkipButton>
    </Styles.SkipButtonContainer>,
    divRef.current,
  )
}
